import React, { Component } from 'react';
import UserService from '../service/userService';
import NavigationBar from "../components/navigationBar";
import AuthTokenService from '../service/authTokenService';
import {
    Link
} from "react-router-dom";

export default class Users extends Component {

    constructor(props) {
        super(props);

        this.userService = new UserService();
        this.authTokenService = new AuthTokenService();

        this.state = {

            username: "",
            userpassword: "",
            userEmail :"",
            users: []
        };
        this.handleChange = this.handleChange.bind(this);
    }

    async getUsers() {
        let result = await this.userService.retrieveUsers();
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                users: result
            })
        }
    }

    componentDidMount() {
        document.title = "Users";
        this.getUsers();
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    showOverlay() {
        document.getElementById("overlay").style.display = "block";
    }

    hideOverlay() {
        document.getElementById("overlay").style.display = "none";
    }

    async createUser(event) {
        event.preventDefault();

        let results = await this.authTokenService.createUser(this.state.username,this.state.userpassword,this.state.userEmail);
        if (results.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.hideOverlay();
            this.getUsers();
        }
    }
    

    render() {
        const users = this.state.users;
        if (!users) return null;

        return (
            <div className='body'>
                <div id="overlay">
                    <div id='LoginDiv' className='content'>
                        <button onClick={this.hideOverlay}>Back</button><br />
                        <h1>Create new User</h1>
                        <form action="#" onSubmit={(event) => { this.createUser(event) }}>
                            <label className="labelLoginForm" htmlFor="username"><b>User name:</b></label><br />
                            <input className="loginInputLabel" type="text" placeholder="username" name="username" value={this.state.username} onChange={this.handleChange} required /><br />
                            <label className="labelLoginForm" htmlFor="userpassword"><b>User password:</b></label><br />
                            <input className="loginInputLabel" type="password" placeholder="user password" name="userpassword" value={this.state.userpassword} onChange={this.handleChange} required /><br />
                            <label className="labelLoginForm" htmlFor="userEmail"><b>User email:</b></label><br />
                            <input className="loginInputLabel" type="text" placeholder="Email" name="userEmail" value={this.state.userEmail} onChange={this.handleChange} required /><br />
                            <button className="buttonLoginSubmit" type="submit">Create User</button>
                        </form>
                    </div>
                </div>
                <NavigationBar {...this.props} />
                <main>
                    <button onClick={this.showOverlay}>Create New</button>
                    <center><h1>Users</h1></center>
                    {this.state.users.map((user) => (
                        <div className="projects-overview-info" key={user.userUuid}>
                            <div>
                                 <Link to={"/Users/" + user.userUuid}>
                                  <div className="card-title">{user.userName}</div>
                                 </Link>
                            </div>
                        </div>
                    ))}
                </main>

            </div>
        )
    };
}




// WEBPACK FOOTER //
// ./src/sites/users.js